import { useEffect, useState } from "react"

export function useBreakpointItems(config: { sm: number; md: number; lg: number; xl: number }) {
  const [items, setItems] = useState(config.sm)

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth
      if (w >= 1280) setItems(config.xl)
      else if (w >= 1024) setItems(config.lg)
      else if (w >= 768) setItems(config.md)
      else setItems(config.sm)
    }

    update()
    window.addEventListener("resize", update)
    return () => window.removeEventListener("resize", update)
  }, [config.sm, config.md, config.lg, config.xl])

  return items
}
